import { schema } from 'normalizr';

const brokerage = new schema.Entity('brokerages');
const lender = new schema.Entity('lenders');
const product = new schema.Entity('products');
const setting = new schema.Entity('settings', {}, { idAttribute: 'key' });
const user = new schema.Entity('users');

brokerage.define({
  settings: [setting],
  users: [user],
});

user.define({
  brokerage,
});

export default {
  brokerage,
  lender,
  product,
  setting,
  user,
};
